import type { StaticImageData } from 'next/image';
import Image from 'next/image';
import type { ReactElement } from 'react';
import React from 'react';
import { validateString } from 'utils/validate-string';

import styles from './logo.module.scss';

interface LogoProps {
  readonly image?: StaticImageData | string | undefined;
  readonly text?: string | undefined;
}

const rootClassName = validateString(styles.root);
const textClassName = validateString(styles.text);
const imageClassName = validateString(styles.image);

function Logo({ image, text }: LogoProps): ReactElement {
  return (
    <div className={rootClassName}>
      {typeof image !== 'undefined' && (
        <Image alt="" className={imageClassName} src={image} />
      )}
      {typeof text !== 'undefined' && <h1 className={textClassName}>{text}</h1>}
    </div>
  );
}

export default Logo;
